window.addEventListener('resize', handleClickNav())

// 点击导航栏跳转
function handleClickNav() {
    const topbarPc = document.getElementById('specialOfferTopbar');
    const topbarMobile = document.getElementById('specialOfferTopbar_mobile');

    const windowSize = window.screen.width
    const topbar = windowSize >= 1024 ? topbarPc : topbarMobile
    const topBarHeight = windowSize >= 1024 ? 66 : 70.39

    topbar.addEventListener('click', function (e) {
        // 只处理 <a> 标签点击
        if (e.target.tagName !== 'A') return;

        const href = e.target.getAttribute('href');
        const activeScreenBar = document.querySelector('.active-screen')
        const barHeight = activeScreenBar ? (windowSize >= 1024 ? 40 : 32) : 0

        // 必须是以 # 开头的本地锚点
        if (!href || !href.startsWith('#')) return;

        const targetId = href.substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
            // 阻止默认的瞬间跳转
            e.preventDefault();
            // 计算目标位置（减去固定导航高度）
            let offsetTop = targetElement.offsetTop - topBarHeight - barHeight * (windowSize >= 1024 ? 1.45 : 2.1) - 60;
            // 平滑滚动
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            });

            // 更新 checked 状态
            topbar.querySelectorAll('a').forEach(link => link.classList.remove('checked'));
            e.target.classList.add('checked');
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    if (window.screen.width >= 1024) {
        const target = document.getElementById('specialOfferTopbar');
        if (!target) return;

        const triggerOffset = 66 + 60; // 触发 fixed 的阈值
        const originalOffsetTop = target.offsetTop;
        // const targetHeight = target.offsetHeight;

        // 创建占位元素，防止 fixed 后页面跳动
        const placeholder = document.createElement('div');
        //   placeholder.style.height = `${targetHeight}px`;
        placeholder.style.height = `1px`;
        placeholder.style.display = 'none';
        placeholder.className = 'placeholder_pc_bar';
        target.parentNode.insertBefore(placeholder, target);

        let isFixed = false;
        let ticking = false;

        function onScroll() {
            if (ticking) return;

            ticking = true;
            requestAnimationFrame(() => {
                const scrollTop = window.scrollY || window.pageYOffset;

                if (scrollTop >= originalOffsetTop - triggerOffset) {
                    if (!isFixed) {
                        target.classList.add('topBar-fixed');
                        placeholder.style.display = 'block';
                        isFixed = true;
                    }
                } else {
                    if (isFixed) {
                        target.classList.remove('topBar-fixed');
                        placeholder.style.display = 'none';
                        isFixed = false;
                    }
                }

                ticking = false;
            });
        }

        // 初始校准
        onScroll();

        window.addEventListener('scroll', onScroll, { passive: true });
    } else {
        const target = document.getElementById('specialOfferTopbar_mobile');
        if (!target) return;

        const triggerOffset = 70 + 68; // 触发 fixed 的阈值
        const originalOffsetTop = target.offsetTop;
        const targetHeight = target.offsetHeight;

        // 创建占位元素，防止 fixed 后页面跳动
        const placeholder = document.createElement('div');
        // placeholder.style.height = `${targetHeight}px`;
        placeholder.style.height = window.screen.width <= 480 ? '60px' : `40px`;
        placeholder.style.display = 'none';
        placeholder.className = 'placeholder_mobile_bar';
        target.parentNode.insertBefore(placeholder, target);

        let isFixed = false;
        let ticking = false;

        function onScroll() {
            if (ticking) return;

            ticking = true;
            requestAnimationFrame(() => {
                const scrollTop = window.scrollY || window.pageYOffset;

                if (scrollTop >= originalOffsetTop - triggerOffset) {
                    if (!isFixed) {
                        target.classList.add('topBar-fixed-mobile');
                        placeholder.style.display = 'block';
                        isFixed = true;
                    }
                } else {
                    if (isFixed) {
                        target.classList.remove('topBar-fixed-mobile');
                        placeholder.style.display = 'none';
                        isFixed = false;
                    }
                }

                ticking = false;
            });
        }

        // 初始校准
        onScroll();

        window.addEventListener('scroll', onScroll, { passive: true });
    }
});

// 点击左右箭头实现滑动
document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('#specialOfferTopbar_mobile .list');
    if (!container) return;

    const btnLeft = document.querySelector('#specialOfferTopbar_mobile .scroll-btn.left');
    const btnRight = document.querySelector('#specialOfferTopbar_mobile .scroll-btn.right');

    // 每次点击滚动的距离（可调）
    const scrollAmount = 160;

    btnLeft.addEventListener('click', () => {
        container.scrollBy({
            left: -scrollAmount,
            behavior: 'smooth'
        });
    });

    btnRight.addEventListener('click', () => {
        container.scrollBy({
            left: scrollAmount,
            behavior: 'smooth'
        });
    });
});
